// import React from "react";
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import MakeAppoinment from '../components/make-appoinment';
import Filter from "../components/Marketfilter";
import useGaspAnimations from '../components/useGsapAnimations'

function MarketFilter() {
 useGaspAnimations()
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
                {/* <section className="breadcrumb-area">
                    <div className="container text-center">
                        <h1>Heat Pumps</h1>
                    </div>
                </section> */}
                {/* <!--End breadcrumb area--> */}

                {/* <!--Start breadcrumb bottom area--> */}
                {/* <section className="breadcrumb-botton-area">
                    <div className="container">
                        <div className="left">
                            <ul>
                                <li><a href="/">Home</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li><a href="services.html">Market</a></li>
                                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                                <li className="active">Food</li>
                            </ul>    
                        </div>
                    </div>
                </section> */}
                {/* <!--End breadcrumb bottom area--> */}

                {/* <!--Start service single area--> */}
                <section id="service-single-area">
                    <div className="container">
                        <div className="row">
                            <Filter/>     
                            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                                <div className="service-single-content">
                                    {/* <!--Start top content --> */}
                                    <div className="row top-content">
                                        <div className="col-md-5 col-sm-12 col-xs-12">
                                            <div className="img-holder wow zoomInStable animated bdFadeUp">
                                                  {/* <Slider {...settings}>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                      <img src="assets/images/projects/project-single.jpg" alt="Awesome Image"/>
                                                  </Slider> */}
                                                   <img src="assets/images/Market-Images/01.webp" alt="Awesome Image"/>
                                             
                                            </div>
                                        </div>
                                        <div className="col-md-7 col-sm-12 col-xs-12">
                                            <div className="textholder">
                                                <div className="sec-title bdFadeUp">
                                                    <h1><span>Food Industry</span></h1>
                                                </div>
                                                <div className="text bdFadeUp">
                                                    <span>End-to-End Refrigeration Solutions for the Food Supply Chain</span>
                                                    <p className="top">Indus Refrigeration plays a vital role in supporting the food industry with state-of-the-art refrigeration systems that preserve freshness, enhance shelf life, and ensure food safety from farm to fork. With extensive experience across dairy, meat, poultry, seafood, bakery, and frozen foods, Indus offers comprehensive cold chain infrastructure tailored to meet the diverse needs of food processors, manufacturers, distributors, and exporters.</p>
                                                    <p>Our advanced industrial refrigeration solutions are designed to maintain optimal temperature and humidity levels throughout food processing, storage, and transportation. Whether it’s chilling milk, freezing seafood, or cold storing fresh produce, Indus systems are built for precision, durability, and energy efficiency, ensuring compliance with FSSAI, HACCP, and global food safety standards.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <!--End top content --> */}
                                    {/* <div className="row">
                                        <div className="col-md-12">
                                            <div className="border"></div>
                                        </div>
                                    </div> */}
                                     <div className="row">
                                        <div className="col-md-12">
                                            <div className="project-description">
                                                <div className="sec-title bdFadeUp">
                                                    <h2>Key Offerings for the Food Sector:</h2>
                                                </div>
                                               
                                                    <p>Pre-cooling and blast freezing units for fruits, vegetables, and meats</p>

                                                    <p>Cold rooms and freezer rooms (-40°C to +15°C) for perishable goods</p>

                                                    <p>Ice plants, IQF systems, and spiral freezers for seafood and meat processing</p>

                                                    <p>Glycol/brine chillers for food processing lines</p>

                                                    <p>Packaged refrigeration systems with scroll, screw, or reciprocating compressors</p>

                                                    <p>Turnkey cold storage and process refrigeration projects with full automation</p>

                                                    <p>
                                                    From small-scale units to large integrated food parks, Indus Refrigeration delivers robust, scalable, and customized refrigeration solutions to help food businesses minimize wastage, maintain product quality, and operate efficiently across India and global markets.
                                                    </p>


                                            </div>    
                                        </div>
                                    </div>
                      
                                </div>
                            </div>  
                        </div>
                    </div>    
                </section>
                {/* <!--End service single area--> */}
                 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default MarketFilter;


